import { render } from "./DependentsHeaderBar.vue?vue&type=template&id=51acfb40&ts=true"
import script from "./DependentsHeaderBar.vue?vue&type=script&lang=ts"
export * from "./DependentsHeaderBar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__